
















































import Vue from 'vue';
import Component from 'vue-class-component';
import NavBar from '@/components/NavBar';
import ChallengeCard from '@/components/ChallengeCard.vue';
import Footer from '@/components/Footer.vue';
import ChallengesSituationsTemplate from '@/components/Challenges/ChallengesSituationsTemplate.vue';
import ChallengesAnySituation from '@/components/Challenges/ChallengesAnySituation.vue';

@Component({
  components: {
    ChallengesAnySituation,
    ChallengesSituationsTemplate,
    NavBar,
    ChallengeCard,
    Footer
  }
})
export default class Challenges extends Vue {

  tabActive() {
    return this.$route.path === '/challenges' ? 'tab-active' : 'tab-initial';
  }

  toTab(data: { name?: string, path?: string }) {
    const tag = this.$route.query.tag;
    const {name, path} = data;
    if (!!tag) {
      return this.$router.push({name, path, query: {tag}})
    } else {
      return this.$router.push({name, path})
    }
  }
}
